module.exports = __webpack_public_path__ + "img/facebook.47b9f2f6.svg";